import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  current_stage_id: string().required(),
});

/**
 * CardUpdateEvent
 *
 * - Evento emitido quando um card é criado.
 */
export class CardUpdateEvent extends CreateCommand(RealtimeEventType.CardUpdate, SCHEMA) {}
